import React, { useCallback, useEffect, useState } from "react";
import VisitNavbar from "../../../component/VisitNavbar";
import {
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  Grid,
  Button,
  Stack,
  Divider,
  Box,
} from "@mui/material";
import FormControl from "@mui/joy/FormControl";

import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import MuiDate from "../../../component/shared/MUIDatePicker";

import { URL, colors } from "../../../utils/constant";

import { useNavigate } from "react-router-dom";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { format } from "date-fns";
import { useHypoglycemia } from "../../../data/talons/Hypoglycemia/useHypoglycemia";
import { ToastContainer } from "react-toastify";
import {
  DatePicker,
  TimePicker,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import {
  getBloodSugarUpdate,
  getHypoUpdate,
  getPageId,
  getPageStatusData,
} from "../../../data/selector/component.selector";
import {
  getLanguage,
  getLanguageNumber,
} from "../../../data/selector/language.selector";
import { setPageId } from "../../../data/reducer/component.reducer";
import { lowerCase, size } from "lodash";
import {
  setHypoFlag,
  setSymptoms,
} from "../../../data/reducer/hypoglycemia.reducer";
import {
  getHypoFlag,
  getSymptoms,
} from "../../../data/selector/hypoglycemia.selector";
import { setSelectedLanguage } from "../../../data/reducer/language.reducer";
import { English } from "../../../Languages/en";
import { Spanish } from "../../../Languages/sp";
import UseBloodSugarRecordList from "../../../data/talons/BloodSugarRecord/UseBloodSugarRecordList";
import useHypoglycemiaList from "../../../data/talons/Hypoglycemia/useHypoglycemiaList";

const Hypoglycemia = ({ selectedVisitId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { fetchBSRecordsList } = UseBloodSugarRecordList();
  const { fetchRecordsList } = useHypoglycemiaList();

  const {
    submitHypoData,
    updateHypoData,
    loading,
    selectedListData,
    handleFlagChange,
    schema,
    otherschema,
  } = useHypoglycemia();

  const symptoms = useSelector(getSymptoms);
  const selector = useSelector(getHypoUpdate);
  const flag = useSelector(getHypoFlag);

  const Language = useSelector(getLanguage);
  const number = useSelector(getLanguageNumber);

  const [time, setTime] = useState(
    size(selectedListData?.HYPO_TIME) > 0
      ? dayjs("01-01-2020 " + selectedListData?.HYPO_TIME)
      : null
  );

  const getValuesString = (combinedText, options) => {
    if (!combinedText) return [];

    const textsArray = combinedText.split("¥");
    const valuesArray = textsArray
      .map((text) => {
        const selected = options.find((item) => item.text === text);
        return selected ? selected.value : null;
      })
      .filter((value) => value !== null); // Filter out any null values in case of a missing text

    return valuesArray;
  };

  const arr = getValuesString(
    selectedListData?.HYPO_SYM,
    English.HypoglycemiaTitles.Symptoms_Options
  );

  const arr2 = getValuesString(
    selectedListData?.HYPO_TREAT,
    English.HypoglycemiaTitles.Treatment_options
  );

  const [otherChecked, setOtherChecked] = useState(
    selectedListData?.HYPO_SYM && selectedListData?.HYPO_SYM.includes("other")
      ? true
      : false
  );

  const initialValue = {
    bloodSugarValue:
      selectedListData?.BS_VALUE !== null ? selectedListData?.BS_VALUE : "",
    symptoms: arr,
    reactionRecognizedBy:
      size(selectedListData?.HYPO_REACT) > 0
        ? English.HypoglycemiaTitles.Reaction_Recognized_By_Options.find(
            (item) => {
              return selectedListData?.HYPO_REACT === item.text;
            }
          )?.value
        : "",
    treatment: arr2,
    otherValue:
      selectedListData?.HYPO_SYMother !== null
        ? selectedListData?.HYPO_SYMother
        : "",
  };

  const resetValue = {
    bloodSugarValue: "",
    symptoms: [],
    reactionRecognizedBy: "",
    treatment: [],
    otherValue: "",
  };

  const [values, setValues] = useState(initialValue);

  const [applyschema, setApplyschema] = useState(schema);
  const [Date, setDate] = useState(
    size(selectedListData?.HYPO_DATE) > 0
      ? dayjs(selectedListData?.HYPO_DATE)
      : null
  );
  const [PageID, setPageID] = useState(0);
  const [errors, setErrors] = useState({
    date: "",
    time: "",
    bloodSugarValue: "",
    symptoms: "",
    reactionRecognizedBy: "",
    treatment: "",
    otherValue: "",
  });
  const [forceUpdate, setForceUpdate] = useState(false);

  const startDate = selectedVisitId?.VisitStartDate;
  const endDate = selectedVisitId?.VisitEndDate;
  const minDate = dayjs(startDate);
  const maxDate = dayjs(endDate);
  const [day, setDay] = useState();

  const handleDayChange = () => {
    const Day = Date?.$D - startDate.split("/")[0] + 1;
    setDay(Day);
  };

  const handleChange = (event) => {
    const { name, value } = event?.target;

    setValues({ ...values, [name]: value });
  };

  const [textField, settextField] = useState(false);
  const pageStatusObj = useSelector(getPageId);
  const bloodSugarSelector = useSelector(getBloodSugarUpdate);
  const pageStatusApiData = useSelector(getPageStatusData);
  const [symptomArray, setSymptomArray] = useState(values?.symptoms);

  useEffect(() => {
    // let RecordName = pageStatusObj?.pageData?.PageName === "Hypoglycemia";

    if (bloodSugarSelector.recordNo === 8) {
      const pageStatusobj = {
        pageData: pageStatusApiData[pageStatusApiData?.length - 1],
      };
      dispatch(setPageId(pageStatusobj));
      setPageID(pageStatusApiData[pageStatusApiData?.length - 1].PageId);
    }
  }, [bloodSugarSelector]);

  useEffect(() => {
    if (!number) {
      dispatch(setSelectedLanguage(English));
    } else if (number == 1) {
      dispatch(setSelectedLanguage(English));
    } else if (number == 2) {
      dispatch(setSelectedLanguage(Spanish));
    }
  }, [number]);

  useEffect(() => {
    if (values.otherValue) {
      settextField(true);
    }
  }, [values.otherValue]);

  useEffect(() => {
    if (otherChecked) {
      settextField(true);
      setApplyschema(otherschema);
    } else {
      // settextField(false);
      setApplyschema(schema);
    }
  }, [otherChecked]);

  useEffect(() => {
    handleDayChange();
  }, [Date]);

  const handleCheckboxChange = useCallback(
    (event) => {
      const { id, checked, name } = event?.target;

      if (checked === true && name) {
        setSymptomArray([...symptomArray, name.toLowerCase()]);
      } else {
        const updatedArray = symptomArray?.filter((item) => item !== name);
        setSymptomArray(updatedArray);
      }
      if (values?.symptoms.length >= 0) {
        setErrors({ ...errors, symptoms: "" });
      }
      if (name === "8" && checked === true) {
        settextField(true);
        setOtherChecked(true);
      } else if (name === "8" && checked === false) {
        settextField(false);
        setOtherChecked(false);
      }
      let updatedSymptoms = values?.symptoms?.includes("¥")
        ? [...values.symptoms?.split("¥")]
        : [...values.symptoms];

      if (checked && !updatedSymptoms?.includes(name)) {
        updatedSymptoms?.push(name);
        // setSymptomArray([...symptomArray, updatedSymptoms]);
      } else if (!checked && updatedSymptoms?.includes(name)) {
        updatedSymptoms = updatedSymptoms?.filter(
          (symptom) => symptom !== name
        );
        // setSymptomArray([...symptomArray, updatedSymptoms]);
      }
      dispatch(setSymptoms(updatedSymptoms));
      setValues({ ...values, symptoms: updatedSymptoms });
    },
    [symptomArray, symptoms, values]
  );

  const handleTreatmentCheckboxChange = (event) => {
    const { id, checked, name } = event?.target;
    if (values?.treatment?.length >= 0) {
      setErrors({ ...errors, treatment: "" });
    }
    let updatedTreatment = values?.treatment?.includes("¥")
      ? [...values.treatment?.split("¥")]
      : [...values.treatment];

    if (checked && !updatedTreatment?.includes(name)) {
      updatedTreatment?.push(name);
    } else if (!checked && updatedTreatment?.includes(name)) {
      updatedTreatment = updatedTreatment?.filter(
        (treatment) => treatment !== name
      );
    }

    // const updatedTreatment = checked
    //   ? [...values.treatment, name]
    //   : values.treatment.filter((treatment) => treatment !== name);

    setValues({ ...values, treatment: updatedTreatment });
  };

  const handleSubmit = useCallback(async () => {
    try {
      const newErrors = {};
      const validationResult = applyschema.validate(values, {
        abortEarly: false,
      });
      // if (otherChecked === true) {
      //   setSymptomArray([...symptomArray, otherChecked]);
      // }
      if (
        validationResult.error ||
        time === null ||
        !dayjs(time).isValid() || // Check if time is null or invalid
        !dayjs(Date).isValid() ||
        Date === null ||
        symptomArray?.length <= 0 ||
        (otherChecked && !values.otherValue)
      ) {
        if (!time || !dayjs(time).isValid()) {
          if (!time) {
            newErrors["time"] = Language.error.Hypoglycemia.time.time;
          } else if (!dayjs(time).isValid()) {
            newErrors["time"] = Language.error.Hypoglycemia.time.validTime;
          }
        }
        if (!Date || !dayjs(Date).isValid()) {
          if (!Date) {
            newErrors["date"] = Language.error.Hypoglycemia.date.date;
          } else if (!dayjs(Date).isValid()) {
            newErrors["date"] = Language.error.Hypoglycemia.date.validDate;
          }
        }
        if (otherChecked === false) {
          setErrors({ ...errors, otherValue: "" });
        } else if (otherChecked && !values.otherValue) {
          newErrors["otherValue"] = Language.error.Hypoglycemia.other.other;
        }

        if (values.symptoms?.length <= 0) {
          newErrors["symptoms"] = Language.error.Hypoglycemia.symptoms.symptoms;
        }
        if (size(symptomArray) <= 0) {
          newErrors["symptoms"] = Language.error.Hypoglycemia.symptoms.symptoms;
        }

        if (values.treatment?.length <= 0) {
          newErrors["treatment"] =
            Language.error.Hypoglycemia.treatment.treatment;
        }
        validationResult.error?.details.forEach((detail) => {
          if (
            detail.path.includes("symptoms") ||
            detail.path.includes("treatment")
          ) {
            // newErrors[detail.path[0]] = "At least one item must be selected.";
          } else {
            newErrors[detail.context.key] = detail.message;
          }
        });
        setErrors(newErrors);
      } else {
        setErrors({});
        // Submit the validated values
        const {
          bloodSugarValue,
          symptoms,
          reactionRecognizedBy,
          treatment,
          otherValue,
        } = values;
        const formattedDate = dayjs(Date.$d).format("DD/MMM/YYYY");
        const formattedTime = dayjs(time).format("h:mm A");
        const symptomsSet = symptoms.join("¥");
        const treatmentSet = treatment.join("¥");
        const submitData = {
          date: formattedDate,
          time: formattedTime,
          bsValue: bloodSugarValue,
          symptoms: symptomsSet,
          reactionRecognizedBy,
          treatment: treatmentSet,
          otValue: otherValue,
          pageId: PageID,
          day: day,
        };
        setValues(resetValue);
        setTime(null);
        setDate(null);
        setForceUpdate((prevState) => !prevState);

        const res = await (flag
          ? updateHypoData(submitData)
          : submitHypoData(submitData));

        if (res === true) {
          if (selector) {
            fetchRecordsList(PageID);
          } else {
            fetchBSRecordsList(PageID);
          }
          setValues(resetValue);
          setTime(null);
          setDate(null);
          setForceUpdate((prevState) => !prevState);
          dispatch(setHypoFlag(false));
          // handleFlagChange();
        }
      }
    } catch (error) {
      console.error("Error while handling form submission:", error);
    }
  }, [symptomArray, symptoms, values, time, Date, day]);

  return (
    <Grid sx={{ pt: 1, backgroundColor: "whitesmoke" }}>
      <ToastContainer />

      <Grid
        sx={{
          paddingRight: 2,
          paddingLeft: 3.5,
          ml: "380px",
          pb: 3,
          mt: 8,
          backgroundColor: "whitesmoke",
          // height: "100vh",
        }}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {/* <Box
            sx={{
              mx: 3,
              my: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography className="fw-bold">
              {selectedVisitId.VisitName}
            </Typography>
            <Typography className="fw-bold">
              {bloodSugarSelector.heading}
            </Typography>
          </Box> */}
        <Grid
          sx={{
            width: "70%",
            backgroundColor: colors.white,
            px: 3,
            py: 2,

            // boxShadow:
            //   "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
          }}
        >
          <Stack direction={"row"} spacing={1} justifyContent={"center"} mt={1}>
            <Typography className="fw-bold">
              {Language.BloodSugarRecords.newRecord}
            </Typography>
          </Stack>
          {/* <Divider className="mt-3" /> */}
          <Grid container mt={3} gap={3}>
            <Grid xs={5.5}>
              <MuiDate
                key={forceUpdate}
                sx={{ width: "100%" }}
                label={Language.HypoglycemiaTitles.Date}
                className="bg-light"
                name="date"
                defaultValue={Date}
                mindate={minDate}
                maxdate={maxDate}
                onChange={(date) => {
                  setDate(date);
                  if (date >= minDate && date <= maxDate) {
                    setErrors({ ...errors, date: "" });
                  } else {
                    setErrors({
                      ...errors,
                      date: "Pick date from current visit",
                    });
                  }
                }}
                // shouldDisableDate={(date) => !isDateInRange(date.$d)}
              />
              {errors.date && (
                <Typography variant="body2" color="error">
                  {errors.date}
                </Typography>
              )}
            </Grid>

            <Grid xs={6} direction={"row"}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimePicker
                  label={Language.HypoglycemiaTitles.Time}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  value={time}
                  onChange={(e) => {
                    setErrors({ ...errors, time: "" });
                    setTime(e);
                  }}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </LocalizationProvider>
              {errors.time && (
                <Typography variant="body2" color="error">
                  {errors.time}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid xs={12}>
              <TextField
                label={Language.HypoglycemiaTitles.Blood_sugar_value}
                fullWidth
                name="bloodSugarValue"
                value={values.bloodSugarValue}
                onChange={(e) => {
                  handleChange(e);
                  setErrors({ ...errors, bloodSugarValue: "" });
                }}
                sx={{ mt: 3 }}
                // required
              />
              {errors.bloodSugarValue && (
                <Typography variant="body2" className="mt-1" color="error">
                  {errors.bloodSugarValue}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid
            style={{ marginTop: "20px" }}
            className="d-flex align-items-center"
            container
          >
            <Grid xs={12}>{Language.HypoglycemiaTitles.Symptoms}</Grid>
            <Grid container>
              {Language.HypoglycemiaTitles.Symptoms_Options.map(
                (item, index) => {
                  const isSelected = symptomArray?.includes(
                    item.value.toLowerCase()
                  );
                  return (
                    <Grid item xs={6} key={index}>
                      <FormControlLabel
                        key={item.value}
                        control={
                          <Checkbox
                            value={item.value}
                            id={item.value}
                            name={item.value}
                            checked={isSelected}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label={item.text}
                      />
                    </Grid>
                  );
                }
              )}
              {textField && (
                <TextField
                  value={values.otherValue}
                  name="otherValue"
                  onChange={(e) => {
                    if (otherChecked === true) {
                      handleChange(e);
                    }
                    setErrors({
                      ...errors,
                      otherValue: "",
                    });
                  }}
                />
              )}
              {textField && errors.otherValue && (
                <Typography variant="body2" color="error">
                  {errors.otherValue}
                </Typography>
              )}
              {errors.symptoms && (
                <Typography variant="body2" color="error">
                  {errors.symptoms}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 3 }}>
            <Grid xs={12}>{Language.HypoglycemiaTitles.Recognize}</Grid>
            <Grid item xs={12}>
              <FormControl>
                <RadioGroup
                  name="reactionRecognizedBy"
                  value={values.reactionRecognizedBy}
                  onChange={(e) => {
                    handleChange(e);
                    if (e.target.value) {
                      setErrors({ ...errors, reactionRecognizedBy: "" });
                    }
                  }}
                >
                  <Grid>
                    {Language.HypoglycemiaTitles.Reaction_Recognized_By_Options.map(
                      (item, index) => (
                        <FormControlLabel
                          key={index}
                          value={item.value}
                          control={
                            <Radio
                              checked={
                                values.reactionRecognizedBy === item.value
                              }
                            />
                          }
                          label={item.text}
                        />
                      )
                    )}
                  </Grid>
                </RadioGroup>
                {errors.reactionRecognizedBy && (
                  <Typography variant="body2" color="error">
                    {errors.reactionRecognizedBy}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            className="d-flex align-items-center"
            style={{ marginTop: "20px" }}
            container
          >
            <Grid xs={12} direction={"column"} alignItems={"center"}>
              {Language.HypoglycemiaTitles.Treatment}
            </Grid>
            <Grid container>
              {Language.HypoglycemiaTitles.Treatment_options.map(
                (item, index) => {
                  const isSelected = values.treatment?.includes(item.value);
                  return (
                    <Grid item xs={6} key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            id={item.value}
                            onChange={handleTreatmentCheckboxChange}
                            checked={isSelected}
                            name={item.value}
                          />
                        }
                        label={item.text}
                      />
                    </Grid>
                  );
                }
              )}
              {errors.treatment && (
                <Typography variant="body2" color="error">
                  {errors.treatment}
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            direction={"row"}
            mt={3}
            gap={2}
            justifyContent={"end"}
            pr={3}
          >
            <Grid>
              <Button
                type="button"
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  width: "7rem",
                  mt: 1,
                  mb: 2,
                  backgroundColor: colors.blue,
                  "&:hover": {
                    backgroundColor: colors.blue,
                  },
                }}
              >
                {Language.ButtonText.Submit}
              </Button>
            </Grid>
            <Grid direction={"row"}>
              <Button
                // type="submit"
                type="button"
                variant="contained"
                onClick={() => navigate(URL.savedRecords)}
                sx={{
                  width: "7rem",
                  mt: 1,
                  mb: 2,
                  backgroundColor: colors.blue,
                  "&:hover": {
                    backgroundColor: colors.blue,
                  },
                }}
              >
                {Language.ButtonText.Cancel}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Hypoglycemia;
